<div aria-labelledby="addTreatmentInjectionModalLabel" class="modal modal-big fade" id="addTreatmentInjectionModal" role="dialog" tabindex="-1" style="display: none; z-index: 9999;">
    <div class="modal-dialog width-900" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button aria-label="Close" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                <h4 class="modal-title">
                    <ng-container *ngIf="cud == 'add'">
                        {{ "VISITORS_MEDICAL.ADD_TREATMENT_INJECTION" | translate }}
                    </ng-container>
                    <ng-container *ngIf="cud == 'edit'">
                        {{ "VISITORS_MEDICAL.EDIT_TREATMENT_INJECTION" | translate }}
                    </ng-container>
                </h4>
            </div>
            <div class="modal-body">
                <ng-container *ngIf="!isLoading">
                    <form [formGroup]="addForm" #aForm="ngForm" class="form-horizontal" (submit)="submit()">
                        <div class="form-group" *ngIf="!visitorId && cud == 'add'">
                            <div class="col-md-3">
                                <label class="control-label control-label-sm" for="visitor_id" >
                                    {{ 'VISITORS_MEDICAL.VISITOR' | translate }} <span class="star">*</span>
                                </label>
                            </div>
                            <div class="col-md-9">
                                <ng-select class="ng-select-input-sm"
                                        id="visitor_id"
                                        formControlName="visitor_id" 
                                        bindValue="id"
                                        bindLabel="showName"
                                        [items]="visitors | async"
                                        [hideSelected]="true"
                                        [loading]="visitorsLoading"
                                        [typeahead]="visitorsInput"
                                        loadingText="{{ 'SHARED.LOADING' | translate }}"
                                        typeToSearchText="{{ 'FILTER.SEARCH_BY_UNIQUE_CODE_FIRSTNAME_LASTNAME' | translate }}"
                                        notFoundText="{{ 'VISITORS.NO_VISITOR_FOUND' | translate }}">
                                    <ng-template ng-footer-tmp>
                                        <p class="add-choices pointer m-0 mt-2 mb-2">
                                            <a href="javascript:void(0)" class="text-primary" (click)="goToAddVisitorUrl()">
                                                {{ 'VISITORS.ADD_VISITOR' | translate }} <i class="fa fa-plus text-success"></i>
                                            </a>
                                        </p>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <fieldset>
                            <legend>{{ "VISITORS_MEDICAL.PER_OS" | translate }}</legend>
                            <div class="form-group">
                                <div class="col-md-3">
                                    <label class="control-label control-label-sm" for="medication_name">
                                        {{ "VISITORS_MEDICAL.NAME_AND_DOSAGE" | translate }} <span class="star">*</span>
                                    </label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text"
                                            class="form-control input-sm"
                                            id="medication_name"
                                            formControlName="medication_name" />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3">
                                    <label class="control-label control-label-sm" for="date_next_injection">
                                        {{ 'FILTER.DATE_NEXT_INJECTION' | translate }}
                                    </label>
                                </div>
                                <div class="col-md-9">
                                    <app-date-picker [datepickerConfig]="datepickerConfig"
                                                    [col]="null"
                                                    [hasResetButton]="true"
                                                    (onDateChanged)="dateChanged($event, 'date_next_injection')"
                                                    #datePickerNextInjection>
                                    </app-date-picker>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3">
                                    <label class="control-label control-label-sm" for="date_begin">
                                        {{ 'FILTER.DATE_BEGIN' | translate }}
                                    </label>
                                </div>
                                <div class="col-md-9">
                                    <app-date-picker [datepickerConfig]="datepickerConfig"
                                                    [col]="null"
                                                    [hasResetButton]="true"
                                                    (onDateChanged)="dateChanged($event, 'date_begin')"
                                                    #datePickerBegin>
                                    </app-date-picker>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3">
                                    <label class="control-label control-label-sm" for="date_end">
                                        {{ 'FILTER.DATE_END' | translate }}
                                    </label>
                                </div>
                                <div class="col-md-9">
                                    <app-date-picker [datepickerConfig]="datepickerConfig"
                                                    [col]="null"
                                                    [hasResetButton]="true"
                                                    (onDateChanged)="dateChanged($event, 'date_end')"
                                                    #datePickerEnd>
                                    </app-date-picker>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3">
                                    <label class="control-label control-label-sm" for="remarks">
                                        {{ "VISITORS_MEDICAL.REMARKS" | translate }}
                                    </label>
                                </div>
                                <div class="col-md-9">
                                    <textarea cols="30"
                                            rows="5"
                                            id="remarks"
                                            class="form-control input-sm"
                                            formControlName="remarks"></textarea>
                                </div>
                            </div>
                        </fieldset>

                        <div class="form-group">
                            <div class="col-md-12">
                                <button type="submit"
                                        class="btn"
                                        [ngClass]="{'btn-default':isSubmitting, 'btn-success': !isSubmitting}"                                                        
                                        [disabled]="!aForm.form.valid || isSubmitting">
                                    <ng-container *ngIf="cud == 'add'">
                                        <i class="fa"
                                            [ngClass]="{'fa-plus': !isSubmitting,
                                                        'fa-spinner fa-spin': isSubmitting}"></i> {{ "SHARED.ADD" | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="cud == 'edit'">
                                        <i class="fa"
                                            [ngClass]="{'fa-edit': !isSubmitting,
                                                        'fa-spinner fa-spin': isSubmitting}"></i> {{ "SHARED.EDIT" | translate }}
                                    </ng-container>
                                </button>
                            </div>
                        </div>
                    </form>
                </ng-container>
                <ng-container *ngIf="isLoading">
                    <app-loading-spinner></app-loading-spinner>
                </ng-container>
            </div>
        </div>
    </div>
</div>